import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store/store'
import axios from 'axios'
import { urlMixin } from '../mixins/url'

Vue.use(VueRouter)

//define routes
const routes = [
  //default
  {
    path: '/',
    redirect: { name: 'home' }
  },
  //wildcard catcher
  {
    path: '*',
    redirect: { name: 'home' }
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    beforeEnter:(to, from, next) => {
      console.log('home beforeEnter agentType:', store.getters.agentType)
      switch (store.getters.agentType) {
        case 'driver':
          next({ name: 'driver-dashboard' })
        break
        case 'company':
          next({ name: 'company-dashboard' })
        break
        default:
          next()
      }
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    beforeEnter:(to, from, next) => {
      if (store.getters.isLoggedIn) {
        //if logged in, go to home
        next({ name: 'home' })
      }
      next()
    }
  },
  {
    path: '/company-signup',
    name: 'company-signup',
    component: () => import('../views/CompanySignup.vue'),
    beforeEnter:(to, from, next) => {
      if (store.getters.isLoggedIn) {
        //TODO: CompanySignup.vue is prepared to be used as loggedIn also, for "adding" companies, but the API is not prepared!
        //if logged in, go to home
        next({ name: 'home' })
      }
      next()
    }
  },
  {
    path: '/company-dashboard',
    name: 'company-dashboard',
    component: () => import('../views/CompanyDashboard.vue'),
    beforeEnter:(to, from, next) => {
      if (!store.getters.isLoggedIn) {
        //not logged in, go to home
        next({ name: 'home' })
      }
      switch (store.getters.agentType) {
        case 'driver':
          //if driver, go to driver-dashboard
          next({ name: 'driver-dashboard' })
        break
      }
      next()
    }
  },
  {
    path: '/qualification-preset',
    name: 'qualification-preset',
    component: () => import('../views/QualificationPreset.vue'),
    beforeEnter:(to, from, next) => {
      if (!store.getters.isLoggedIn) {
        //not logged in, go to home
        next({ name: 'home' })
      }
      switch (store.getters.agentType) {
        case 'driver':
          //if driver, go to driver-dashboard
          next({ name: 'driver-dashboard' })
        break
      }
      next()
    }
  },
  {
    path: '/driver-signup',
    name: 'driver-signup',
    component: () => import('../views/DriverSignup.vue'),
    beforeEnter:(to, from, next) => {
      if (store.getters.isLoggedIn) {
        //if logged in, go to home
        next({ name: 'home' })
      }
      next()
    }
  },
  {
    path: '/driver-dashboard',
    name: 'driver-dashboard',
    component: () => import('../views/DriverDashboard.vue'),
    beforeEnter:(to, from, next) => {
      if (!store.getters.isLoggedIn) {
        //not logged in, go to home
        next({ name: 'home' })
      }
      switch (store.getters.agentType) {
        case 'company':
          //if driver, go to driver-dashboard
          next({ name: 'company-dashboard' })
        break
      }
      next()
    }
  },
  {
    path: '/switch-account',
    name: 'switch-account',
    component: () => import('../views/SwitchAccount.vue'),
    beforeEnter:(to, from, next) => {
      if (!store.getters.hasMultipleAgentAccess) {
        //does not have multiple agens access - go home
        next({ name: 'home' })
      }
      next()
    }
  },
  {
    path: '/my-profile',
    name: 'my-profile',
    component: () => import('../views/MyProfile.vue'),
    beforeEnter:(to, from, next) => {
      if (!store.getters.isLoggedIn) {
        //not logged in, go to home
        next({ name: 'home' })
      }
      next()
    }
  },
  {
    path: '/user-edit/:id',
    name: 'user-edit',
    props(route) {
      //make sure id prop is integer
      const props = { ...route.params }
      props.id = +props.id
      return props
    },    
    component: () => import('../views/UserEdit.vue'),
    beforeEnter:(to, from, next) => {
      if (!store.getters.isLoggedIn) {
        //not logged in, go to home
        next({ name: 'home' })
      }
      next()
    }
  },
  {
    path: '/driver-edit/:id',
    name: 'driver-edit',
    props(route) {
      //make sure id prop is integer
      const props = { ...route.params }
      props.id = +props.id
      return props
    },    
    component: () => import('../views/DriverEdit.vue'),
    beforeEnter:(to, from, next) => {
      if (store.getters.agentType != 'driver') {
        //not driver, go to home
        next({ name: 'home' })
      }
      next()
    }
  },
  {
    path: '/matching-edit/:id',
    name: 'matching-edit',
    props(route) {
      //make sure id prop is integer
      const props = { ...route.params }
      props.id = +props.id
      return props
    },    
    component: () => import('../views/MatchingEdit.vue'),
    beforeEnter:(to, from, next) => {
      if (store.getters.agentType != 'driver') {
        //not driver, go to home
        next({ name: 'home' })
      }
      next()
    }
  },
  {
    path: '/company-edit/:id',
    name: 'company-edit',
    props(route) {
      //make sure id prop is integer
      const props = { ...route.params }
      props.id = +props.id
      return props
    },    
    component: () => import('../views/CompanyEdit.vue'),
    beforeEnter:(to, from, next) => {
      if (store.getters.agentType != 'company') {
        //not company, go to home
        next({ name: 'home' })
      }
      next()
    }
  },
  {
    path: '/qualification-preset-edit/:id',
    name: 'qualification-preset-edit',
    props(route) {
      //make sure id prop is integer
      const props = { ...route.params }
      props.id = +props.id
      return props
    },    
    component: () => import('../views/QualificationPresetEdit.vue'),
    beforeEnter:(to, from, next) => {
      if (!store.getters.isLoggedIn) {
        //not logged in, go to home
        next({ name: 'home' })
      }
      switch (store.getters.agentType) {
        case 'driver':
          //if driver, go to home
          next({ name: 'home' })
        break
      }
      next()
    }
  },
  {
    path: '/assignment-edit/:id',
    name: 'assignment-edit',
    props(route) {
      //make sure id prop is integer
      const props = { ...route.params }
      props.id = +props.id
      return props
    },    
    component: () => import('../views/AssignmentEdit.vue'),
    beforeEnter:(to, from, next) => {
      if (!store.getters.isLoggedIn) {
        //not logged in, go to home
        next({ name: 'home' })
      }
      switch (store.getters.agentType) {
        case 'driver':
          //if driver, go to home
          next({ name: 'home' })
        break
      }
      next()
    }
  },
  {
    path: '/driver/:uuid',
    name: 'driver',
    props: true,
    component: () => import('../views/Driver.vue'),
    beforeEnter:(to, from, next) => {
      if (!store.getters.isLoggedIn) {
        //not logged in, go to home
        next({ name: 'home' })
      }
      next()
    }
  },
  {
    path: '/assignment/:uuid',
    name: 'assignment',
    props: true,
    component: () => import('../views/Assignment.vue'),
    beforeEnter:(to, from, next) => {
      if (!store.getters.isLoggedIn) {
        //not logged in, go to home
        next({ name: 'home' })
      }
      next()
    }
  },
  {
    path: '/assignment/matched-drivers/:id',
    name: 'matched-drivers',
    props(route) {
      //make sure id prop is integer
      const props = { ...route.params }
      props.id = +props.id
      return props
    },    
    component: () => import('../views/MatchedDrivers.vue'),
    beforeEnter:(to, from, next) => {
      if (!store.getters.isLoggedIn) {
        //not logged in, go to home
        next({ name: 'home' })
      }
      switch (store.getters.agentType) {
        case 'driver':
          //if driver, go to home
          next({ name: 'home' })
        break
      }
      next()
    }
  },
  {
    path: '/assignment/signed-drivers/:id',
    name: 'signed-drivers',
    props(route) {
      //make sure id prop is integer
      const props = { ...route.params }
      props.id = +props.id
      return props
    },    
    component: () => import('../views/SignedDrivers.vue'),
    beforeEnter:(to, from, next) => {
      if (!store.getters.isLoggedIn) {
        //not logged in, go to home
        next({ name: 'home' })
      }
      switch (store.getters.agentType) {
        case 'driver':
          //if driver, go to home
          next({ name: 'home' })
        break
      }
      next()
    }
  },
  // admin pages
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/Admin.vue'),
    beforeEnter:(to, from, next) => {
      if (!store.getters.isAdmin) {
        //not is admin, go to home
        next({ name: 'home' })
      }
      next()
    },
    children: [
      {
        path: '/admin/companies',
        name: 'admin-companies',
        props: true,
        component: () => import('../views/AdminCompanies.vue'),
      },
      {
        path: '/admin/company/:uuid',
        name: 'admin-company',
        props: true,
        component: () => import('../views/AdminCompany.vue'),
      },
      {
        path: '/admin/assignments',
        name: 'admin-assignments',
        props: true,
        component: () => import('../views/AdminAssignments.vue'),
      },
      {
        path: '/admin/assignment/:uuid',
        name: 'admin-assignment',
        props: true,
        component: () => import('../views/AdminAssignment.vue'),
      },
      {
        path: '/admin/drivers',
        name: 'admin-drivers',
        props: true,
        component: () => import('../views/AdminDrivers.vue'),
      },
      {
        path: '/admin/driver/:uuid',
        name: 'admin-driver',
        props: true,
        component: () => import('../views/AdminDriver.vue'),
      },
      {
        path: '/admin/fortnox',
        name: 'admin-fortnox',
        props: true,
        component: () => import('../views/AdminFortnox.vue'),
      },
      {
        path: '/admin/fortnox-article/:uuid',
        name: 'admin-fortnox-article',
        props: true,
        component: () => import('../views/AdminFortnoxArticle.vue'),
      },
    ]
  },
]

//init router
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//make sure we load possible localStorage before we enter a route (mainly on first load)
router.beforeEach((to, from, next) => {
  console.log('router beforeEach')
    if (store.state.firstRouterHasLoaded) {
      //this is not initial router load, just go on
      next()
    } else {
      //set firstRouterHasLoaded to true so we do not consider this again
      store.dispatch('setFirstRouterHasLoaded')
      //this is the initial router load
      console.log("on first router load")
      //set isStandalone (PWA or browser)
      store.dispatch('setIsStandalone')
      //get possible access_token from localstorage
      let access_token = localStorage.getItem('access_token')
      if (!access_token) {
        //not logged in - proceed and let the respective "route guards" determine where to go
        next()
      } else {
        //store access_token in store
        console.log('has access_token', access_token)
        store.dispatch("setAccessToken", access_token)
        //init postData
        let postData = {}
        //get possible cmpId from localstorage
        let cmpId = localStorage.getItem('cmpId')
        if (cmpId) {
          console.log('has cmpId', cmpId)
          //post cmpId in order to "login" at specific cmpId
          postData.cmpId = cmpId
        }
        //try to fetch loggedInData for access_token
        let config = {
          headers: {
            'Authorization': access_token
          }
        }
        let url = urlMixin.methods.url_composeApiUrl('/user/getLoggedInData')
        axios.post(url, postData, config)
          .then(response => {
            console.log('getLoggedInData response', response)
            if (response.data.success) {
              //success
              //call action onAuth in store
              let dataToDispatch = {
                loggedInData: response.data.returnData.loggedInData
              }
              store.dispatch('onAuth', dataToDispatch).then(() => {
                //ok to go to next
                next()
              })
            } else {
              //non success - go to home
              next({ name: 'home' })
            }
          })
          .catch(error => {
            console.log(error.toString())
            //error - go to home
            next({ name: 'home' })
          })
      }
    }
})
export default router
